<div class="layout-container">
  <app-emergency01-top-bar></app-emergency01-top-bar>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>